import { apiUrl } from '../../../settings'

export const enrollmentLetterUrl = () => {
  return apiUrl + '/api-fcmt-onshore/createEnrollmentLetter'
}
export const paymentReceiptUrl = () => {
  return apiUrl + '/api-fcmt-onshore/createPaymentReceipt'
}
